import React from 'react';
import { FaClock, FaEnvelope, FaPhone, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';
import './VCNRContactHospitalBanner.css';
import doctorImage from '../../Assets/health/image 78.png';
import logoIcon from '../../Assets/contact/VCNR-purple-logo.png'; 
import EnquiryFormSection from "../../components/Contact/EnquiryFormSection"

const VcnrHospitalBanner = () => {
  return (
    <div className="vcnr-wrapper">
      <div className="vcnr-banner-container">
        <div className="vcnr-banner-left">
          <h1 className="vcnr-title">
            <img src={logoIcon} alt="VCNR Logo" className="vcnr-logo" />
            <span style={{marginTop: "-20px", fontSize: "2rem"}}>Group</span> 
          </h1>
          <div className="vcnr-info">
            <p><FaClock /> Sun-Fri: 10.00–6.00</p>
            <p><FaEnvelope /> info@vcnrenterprise.com</p>
            <p><FaPhone /> +91 97397 89992</p>
            <p><FaWhatsapp /> VCNR Appointments : +91 63604 16666</p>
            <p style={{display:"flex"}}><FaMapMarkerAlt size={30}/> 3CR5+977 VCNR Towers, 135, BH Rd, opp. Binnamangala Nursery, Vinayaka Nagar, Sadashiva Nagara, Nelamangala Town, Nagarur, Karnataka 562123</p>
          </div>
          {/* <button className="vcnr-button">Talk to a Doctor!</button> */}
        </div>
        <div className="vcnr-banner-right">
          <img src={doctorImage} alt="Doctor" className="vcnr-doctor-image" />
        </div>
      </div>
    </div>

  );
};

export default VcnrHospitalBanner;
